// extracted by mini-css-extract-plugin
export default {"container":"ProfileLayout_container__fnL1J","content":"ProfileLayout_content__6cYjV","title":"ProfileLayout_title__9giF1","text":"ProfileLayout_text__-1k0h"};